import { render } from "./cloudcredential.vue?vue&type=template&id=2355de00"
import script from "./cloudcredential.vue?vue&type=script&lang=js"
export * from "./cloudcredential.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__